import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  Typography,
  Button,
  Divider,
  FormGroup,
  Checkbox,
  CircularProgress,
} from "@mui/material";

import { Colors } from "../../utils/constants";

import FilterDMGs from "../VTBPlayer/VTBModel";
import FilterNCGCategory from "../VTBPlayer/VTBModel";
import FilterYearFrom from "../VTBPlayer/VTBModel";
import FilterPublisherName from "../VTBPlayer/VTBModel";
import FilterGender from "../VTBPlayer/VTBModel";
import FilterAgeGroup from "../VTBPlayer/VTBModel";
import FilterDiagnosis from "../VTBPlayer/VTBModel";
import FilterPresentingCentre from "../VTBPlayer/VTBModel";
import FilterPrimarySite from "../VTBPlayer/VTBModel";
import FilterStageOfCancer from "../VTBPlayer/VTBModel";

import ControlPointIcon from "@mui/icons-material/ControlPoint";

import {
  checkDuplicateFilter,
  getParamsByName,
  goToTop,
} from "../../utils/helper";

import { useAppSelector, useAppDispatch } from "../../store/hooks";

import {
  clearNCGAllFilters,
  updateNCGAgeGroup,
  updateNCGCategory,
  updateNCGDiagnosis,
  updateNCGDmg,
  updateNCGGender,
  updateNCGPresentingCentre,
  updateNCGPrimarySite,
  updateNCGPublisherName,
  updateNCGStageOfCancer,
  updateNCGYearFrom,
} from "../../store/slice/ncgDetailsSlice";

interface PropType {
  jsonFacets?: any;
}

const VTBSearchFilter = (props: PropType) => {
  // Props
  const { jsonFacets } = props;
  const dispatch = useAppDispatch();
  const searchTerm = getParamsByName("searchterm");
  const selectedFilters = useAppSelector((state) => state.filterReducer);

  const [triggerCount, setTriggerCount] = useState<number>(0);

  const [filterDMGsModalStatus, setFilterDMGsModalStatus] = useState(false);
  const [filterNCGYearFromModalStatus, setFilterNCGYearFromModalStatus] =
    useState(false);

  const [
    filterNCGPublisherNameModalStatus,
    setFilterNCGPublisherNameModalStatus,
  ] = useState(false);

  const [filterNCGGenderModalStatus, setFilterNCGGenderModalStatus] =
    useState(false);

  const [filterNCGAgeGroupModalStatus, setFilterNCGAgeGroupModalStatus] =
    useState(false);

  const [filterNCGDiagnosisModalStatus, setFilterNCGDiagnosisModalStatus] =
    useState(false);

  const [
    filterNCGPresentingCentreModalStatus,
    setFilterNCGPresentingCentreModalStatus,
  ] = useState(false);

  const [filterNCGPrimarySiteModalStatus, setFilterNCGPrimarySiteModalStatus] =
    useState(false);

  const [filterNCGCategoryModalStatus, setFilterNCGCategoryModalStatus] =
    useState(false);

  const [
    filterNCGStageOfCancerModalStatus,
    setFilterNCGStageOfCancerModalStatus,
  ] = useState(false);

  const vTBSearchDetails = useAppSelector((state) => state.ncgDetails);

  const vTBDetailsLoading = useAppSelector(
    (state: any) => state.ncgDetails?.loading,
  );

  useEffect(() => {
    if (triggerCount) applySearch();
  }, [triggerCount]);

  // Handle Filter DMG modal status changes
  const handleChangeFilterDMG = () => {
    setFilterDMGsModalStatus(false);
  };

  const handleChangeFilterCategory = () => {
    setFilterNCGCategoryModalStatus(false);
  };

  const handleChangeFilterYearFrom = () => {
    setFilterNCGYearFromModalStatus(false);
  };

  const handleChangeFilterPublisher = () => {
    setFilterNCGPublisherNameModalStatus(false);
  };

  const handleChangeFilterGender = () => {
    setFilterNCGGenderModalStatus(false);
  };

  const handleChangeFilterAgeGroup = () => {
    setFilterNCGAgeGroupModalStatus(false);
  };

  const handleChangeFilterDiagnosis = () => {
    setFilterNCGDiagnosisModalStatus(false);
  };

  const handleChangeFilterPcenter = () => {
    setFilterNCGPresentingCentreModalStatus(false);
  };
  const handleChangeFilterSite = () => {
    setFilterNCGPrimarySiteModalStatus(false);
  };

  const handleChangeFilterStageOfCancer = () => {
    setFilterNCGStageOfCancerModalStatus(false);
  };

  // Get DMG values
  const getDMGTypeValues = (data: string[]) => {
    dispatch(updateNCGDmg(data));

    // let filteredArr = allAppliedFilter.filter(
    //   (obj) => obj?.key === "countryOfPublication",
    // );

    // let appliedFilter: any[] = [];
    // data.forEach((val) => {
    //   const isExist = checkDuplicateFilter(allAppliedFilter, val);
    //   if (!isExist) {
    //     appliedFilter.push({
    //       key: "countryOfPublication",
    //       value: val,
    //     });
    //   }
    // });

    // dispatch(updateAllFilter(appliedFilter));
    // dispatch(updateQueries(appliedFilter));
    // dispatch(filterUpdate(filteredArr, "countryOfPublication"));
    // logBasicSearchUsageData(58);
  };

  const getCategoryTypeValues = (data: string[]) => {
    dispatch(updateNCGCategory(data));
  };

  const getYearFromTypeValues = (data: string[]) => {
    dispatch(updateNCGYearFrom(data));
  };

  const getPublisherTypeValues = (data: string[]) => {
    dispatch(updateNCGPublisherName(data));
  };

  const getGenderTypeValues = (data: string[]) => {
    dispatch(updateNCGGender(data));
  };
  const getAgeGroupTypeValues = (data: string[]) => {
    dispatch(updateNCGAgeGroup(data));
  };
  const getrDiagnosisTypeValues = (data: string[]) => {
    dispatch(updateNCGDiagnosis(data));
  };
  const getPresentingCentreTypeValues = (data: string[]) => {
    dispatch(updateNCGPresentingCentre(data));
  };
  const getPrimarySiteTypeValues = (data: string[]) => {
    dispatch(updateNCGPrimarySite(data));
  };
  const getStageOfCancerTypeValues = (data: string[]) => {
    dispatch(updateNCGStageOfCancer(data));
  };

  // function apply filter
  async function applyFilter() {
    // if (!searchTerm) return;
    setTriggerCount((prev) => prev + 1);

    goToTop();
  }

  async function applySearch() {
    // dispatch(search("", null, true));
    // goToTop();
  }

  // clear all filters
  function handleClearAllFilters() {
    // logBasicSearchUsageData(61);
    // logBasicSearchUsageDataONOSClearALL(61);
    dispatch(clearNCGAllFilters());

    setTriggerCount((prev) => prev + 1);
    // dispatch(search());
  }

  return (
    <>
      <Box sx={webStyle.leftBox}>
        {/* <Box sx={[webStyle.flexBox]}> */}
        <Box sx={[webStyle.flexBox, webStyle.filterHeader]}>
          <Typography
            sx={{
              alignSelf: "center",
              fontFamily: "Lora",
              fontWeight: 700,
              fontSize: "1.125rem",

              display: "flex",
              alignItems: "center",
              gap: "8px", // Space between text and loader
            }}
          >
            Filters
            {vTBDetailsLoading && (
              <CircularProgress
                size={24}
                sx={{
                  color: "primary",
                }}
              />
            )}
          </Typography>

          <Button onClick={handleClearAllFilters}>Clear All</Button>
        </Box>

        {Array.isArray(jsonFacets?.dmg?.buckets) &&
        jsonFacets?.dmg?.buckets.length ? (
          <>
            {/* <Box sx={[webStyle.flexBox, webStyle.filterRow]}> */}
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                DMGs
              </Typography>
              <Button onClick={() => setFilterDMGsModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.yearfrom?.buckets) &&
        jsonFacets?.yearfrom?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Year
              </Typography>
              <Button onClick={() => setFilterNCGYearFromModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {/* {Array.isArray(jsonFacets?.publisher_name?.buckets) &&
        jsonFacets?.publisher_name?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Publisher
              </Typography>
              <Button
                onClick={() => setFilterNCGPublisherNameModalStatus(true)}
              >
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null} */}

        {Array.isArray(jsonFacets?.gender?.buckets) &&
        jsonFacets?.gender?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Gender
              </Typography>
              <Button onClick={() => setFilterNCGGenderModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.age_group?.buckets) &&
        jsonFacets?.age_group?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Age Group
              </Typography>
              <Button onClick={() => setFilterNCGAgeGroupModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.diagnosis?.buckets) &&
        jsonFacets?.diagnosis?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Diagnosis
              </Typography>
              <Button onClick={() => setFilterNCGDiagnosisModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.presenting_centre?.buckets) &&
        jsonFacets?.presenting_centre?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Presenting Centre
              </Typography>
              <Button
                onClick={() => setFilterNCGPresentingCentreModalStatus(true)}
              >
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.primary_site?.buckets) &&
        jsonFacets?.primary_site?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Primary Site
              </Typography>
              <Button onClick={() => setFilterNCGPrimarySiteModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.category?.buckets) &&
        jsonFacets?.category?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Category
              </Typography>
              <Button onClick={() => setFilterNCGCategoryModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.stage_of_cancer?.buckets) &&
        jsonFacets?.stage_of_cancer?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox, webStyle.filterRow]}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Lora"}
                fontWeight={"600"}
              >
                Stage Of Cancer
              </Typography>
              <Button
                onClick={() => setFilterNCGStageOfCancerModalStatus(true)}
              >
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}
      </Box>

      {/* Filter popups */}
      <FilterDMGs
        isOpen={filterDMGsModalStatus}
        handleClose={handleChangeFilterDMG}
        modalName="Filter DMGs"
        getFilterdValues={getDMGTypeValues}
        filterData={jsonFacets?.dmg?.buckets}
        applyFilter={applyFilter}
        placeholderName="DMG's name"
        appliedFilterValues={vTBSearchDetails?.dmg}
        facetKey="dmg"
      />
      <FilterNCGCategory
        isOpen={filterNCGCategoryModalStatus}
        handleClose={handleChangeFilterCategory}
        modalName="Filter Category"
        getFilterdValues={getCategoryTypeValues}
        filterData={jsonFacets?.category?.buckets}
        applyFilter={applyFilter}
        placeholderName="Category name"
        appliedFilterValues={vTBSearchDetails?.category}
        facetKey="category"
      />
      <FilterYearFrom
        isOpen={filterNCGYearFromModalStatus}
        handleClose={handleChangeFilterYearFrom}
        modalName="Filter Year"
        getFilterdValues={getYearFromTypeValues}
        filterData={jsonFacets?.yearfrom?.buckets}
        applyFilter={applyFilter}
        placeholderName="Year"
        appliedFilterValues={vTBSearchDetails?.yearfrom}
        facetKey="yearfrom"
      />
      <FilterPublisherName
        isOpen={filterNCGPublisherNameModalStatus}
        handleClose={handleChangeFilterPublisher}
        modalName="Filter Publisher"
        getFilterdValues={getPublisherTypeValues}
        filterData={jsonFacets?.publisher_name?.buckets}
        applyFilter={applyFilter}
        placeholderName="Publisher name"
        appliedFilterValues={vTBSearchDetails?.publisher_name}
        facetKey="publisher_name"
      />
      <FilterGender
        isOpen={filterNCGGenderModalStatus}
        handleClose={handleChangeFilterGender}
        modalName="Filter Gender"
        getFilterdValues={getGenderTypeValues}
        filterData={jsonFacets?.gender?.buckets}
        applyFilter={applyFilter}
        placeholderName="Gender"
        appliedFilterValues={vTBSearchDetails?.gender}
        facetKey="gender"
      />
      <FilterAgeGroup
        isOpen={filterNCGAgeGroupModalStatus}
        handleClose={handleChangeFilterAgeGroup}
        modalName="Filter Age Group"
        getFilterdValues={getAgeGroupTypeValues}
        filterData={jsonFacets?.age_group?.buckets}
        applyFilter={applyFilter}
        placeholderName="Age Group"
        appliedFilterValues={vTBSearchDetails?.age_group}
        facetKey="age_group"
      />
      <FilterDiagnosis
        isOpen={filterNCGDiagnosisModalStatus}
        handleClose={handleChangeFilterDiagnosis}
        modalName="Filter Diagnosis"
        getFilterdValues={getrDiagnosisTypeValues}
        filterData={jsonFacets?.diagnosis?.buckets}
        applyFilter={applyFilter}
        placeholderName="Diagnosis name"
        appliedFilterValues={vTBSearchDetails?.diagnosis}
        facetKey="diagnosis"
      />
      <FilterPresentingCentre
        isOpen={filterNCGPresentingCentreModalStatus}
        handleClose={handleChangeFilterPcenter}
        modalName="Filter Presenting Centre"
        getFilterdValues={getPresentingCentreTypeValues}
        filterData={jsonFacets?.presenting_centre?.buckets}
        applyFilter={applyFilter}
        placeholderName="Presenting Centre name"
        appliedFilterValues={vTBSearchDetails?.presenting_centre}
        facetKey="presenting_centre"
      />
      <FilterPrimarySite
        isOpen={filterNCGPrimarySiteModalStatus}
        handleClose={handleChangeFilterSite}
        modalName="Filter Primary Site"
        getFilterdValues={getPrimarySiteTypeValues}
        filterData={jsonFacets?.primary_site?.buckets}
        applyFilter={applyFilter}
        placeholderName=" Primary Site name"
        appliedFilterValues={vTBSearchDetails?.primary_site}
        facetKey="primary_site"
      />
      <FilterStageOfCancer
        isOpen={filterNCGStageOfCancerModalStatus}
        handleClose={handleChangeFilterStageOfCancer}
        modalName="Filter Stage of Cancer"
        getFilterdValues={getStageOfCancerTypeValues}
        filterData={jsonFacets?.stage_of_cancer?.buckets}
        applyFilter={applyFilter}
        placeholderName="Stage of Cancer name"
        appliedFilterValues={vTBSearchDetails?.stage_of_cancer}
        facetKey="stage_of_cancer"
      />
    </>
  );
};

export default VTBSearchFilter;

const webStyle = {
  flexBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  leftBox: {
    // width: "92%",
    // maxWidth: "340px",
    width: "100%",
    maxWidth: "none",
    boxSizing: "border-box",
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.gray_1000,
    borderRadius: 2,
    // marginTop: "3%",
    // padding: "7%",
    marginTop: "12px",

    padding: {
      xs: "16px",
      sm: "18px",
      md: "20px",
    },
    boxShadow: 1,
  },
  titleHeader: {
    fontFamily: "Lora",
    fontWeight: 700,
    textAlign: "left",
    fontSize: "1.125rem",
  },

  filterHeader: {
    width: "100%",
    gap: 1,
    paddingBottom: "8px",
  },

  filterRow: {
    width: "100%",

    minHeight: "52px",

    padding: "8px 0",

    gap: 1,

    boxSizing: "border-box",
  },

  addButton: {
    minWidth: "36px",
    width: "36px",
    height: "36px",

    padding: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    flexShrink: 0,
  },
};
